<p>{{ 'DIPRSRegistration.customerIdentification.introduction.help.modal.primaryPolicyHolder' | authTranslate }}</p>

<div class="row td-toolbar">
  <div class="col-sm-6 mx-auto">
    <button class="btn btn-block td-btn-primary-light" (click)="closeBtnClick()">
      {{ 'DIPRSRegistration.customerIdentification.introduction.help.modal.close' | authTranslate }}
    </button>
  </div>
</div>
